"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
var Editor_static_1 = require("../Editor.static");
exports.localText = {
    discard: 'Discard',
    save: 'Save',
    tooltipSave: "Save (".concat(Editor_static_1.modKey, "+S)"),
};
